/**
 * Rotas públicas configuráveis por ambiente.
 * CRA (legado): defaults abaixo.
 * Template Vite: definir REACT_APP_* via vite.config define.
 */
export const publicNavigation = {
  postLogin: process.env.REACT_APP_POST_LOGIN_PATH || '/dashboard',
  register: process.env.REACT_APP_REGISTER_PATH || '/register',
  login: process.env.REACT_APP_LOGIN_PATH || '/',
};

/** Callback opcional — template Hyper define em LegacyLoginShell. */
export function syncPlatformAuth(response, email) {
  if (typeof window !== 'undefined' && typeof window.__VERT_SYNC_AUTH__ === 'function') {
    window.__VERT_SYNC_AUTH__(response, email);
  }
}
